module.exports = __webpack_public_path__ + "img/brown-carpet-grass-02.1b4e9e4d.png";